export default "__VITE_ASSET__f4033adc__"